import { useT } from '../i18n';

export function Loading({ label }: { label?: string }) {
  const t = useT();
  return (
    <p role="status" aria-live="polite" className="py-10 text-[15px] text-lab">
      <span className="mr-3 inline-block h-[1px] w-8 animate-pulse bg-lab align-middle" aria-hidden />
      {label ?? t('app.loading')}
    </p>
  );
}
